module.exports = __webpack_public_path__ + "048a889d92af99f363940a4222ff2e73.svg";